document.addEventListener("DOMContentLoaded", () => {

  const header = document.querySelector("#ctp-header");
  const toggle = document.querySelector(".ctp-toggle");
  const mobileMenu = document.querySelector(".ctp-mobile-menu");
  const body = document.body;

  if (!header) return;

  /*=========================
    Sticky Header
  =========================*/

  function stickyHeader() {

    if (window.scrollY > 40) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }

  }

  stickyHeader();

  window.addEventListener("scroll", stickyHeader);

  /*=========================
    Mobile Menu
  =========================*/

  if (toggle && mobileMenu) {

    toggle.addEventListener("click", function () {

      this.classList.toggle("active");

      mobileMenu.classList.toggle("active");

      body.classList.toggle("menu-open");

    });

  }

  /*=========================
    Close Menu
  =========================*/

  document.addEventListener("click", function (e) {

    if (
      mobileMenu &&
      mobileMenu.classList.contains("active") &&
      !mobileMenu.contains(e.target) &&
      !toggle.contains(e.target)
    ) {

      mobileMenu.classList.remove("active");

      toggle.classList.remove("active");

      body.classList.remove("menu-open");

    }

  });

  /*=========================
    ESC Close
  =========================*/

  document.addEventListener("keydown", function (e) {

    if (e.key === "Escape") {

      mobileMenu.classList.remove("active");

      toggle.classList.remove("active");

      body.classList.remove("menu-open");

    }

  });

});